import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const TRIGGER_PF_INSUREDS_FETCH_REQUEST = "TRIGGER_PF_INSUREDS_FETCH_REQUEST";
export const TRIGGER_PF_INSUREDS_UPDATE_REQUEST = "TRIGGER_PF_INSUREDS_UPDATE_REQUEST";

export interface PFInsuredUser {
  userId: string;
  user: {
    email: string;
    profile: {
      firstName: string;
      lastName: string;
    };
    PFPolicyInput: any[];
  };
  insuranceCompanyId: string;
  insuranceProductId: string;
}

export interface PFInsuredsResponse {
  status: string;
  data: PFInsuredUser[];
}

interface COMMON_TYPE {
  data: null | PFInsuredsResponse;
  error: null | any;
  loading: boolean;
}

interface INITIAL_STATE {
  insureds: COMMON_TYPE;
  updateInsured: COMMON_TYPE;
}

const initialState: INITIAL_STATE = {
  insureds: { data: null, error: null, loading: false },
  updateInsured: { data: null, error: null, loading: false },
};

export const pfInsuredsSlice = createSlice({
  name: "pfInsureds",
  initialState,
  reducers: {
    pfInsuredsLoading: (state) => {
      state.insureds = {
        loading: true,
        data: state.insureds.data,
        error: null,
      };
    },
    pfInsuredsFetchSuccess: (state, action: PayloadAction<PFInsuredsResponse>) => {
      state.insureds = {
        loading: false,
        data: action.payload,
        error: null,
      };
    },
    pfInsuredsFetchError: (state, action: PayloadAction<any>) => {
      state.insureds = {
        loading: false,
        data: null,
        error: action.payload,
      };
    },
    pfInsuredUpdateLoading: (state) => {
      state.updateInsured = {
        loading: true,
        data: null,
        error: null,
      };
    },
    pfInsuredUpdateSuccess: (state, action: PayloadAction<any>) => {
      state.updateInsured = {
        loading: false,
        data: action.payload,
        error: null,
      };
    },
    pfInsuredUpdateError: (state, action: PayloadAction<any>) => {
      state.updateInsured = {
        loading: false,
        data: null,
        error: action.payload,
      };
    },
    resetPfInsureds: (state) => {
      state.insureds = {
        loading: false,
        data: null,
        error: null,
      };
    },
    resetPfInsuredUpdate: (state) => {
      state.updateInsured = {
        loading: false,
        data: null,
        error: null,
      };
    },
  },
});

export const {
  pfInsuredsLoading,
  pfInsuredsFetchSuccess,
  pfInsuredsFetchError,
  pfInsuredUpdateLoading,
  pfInsuredUpdateSuccess,
  pfInsuredUpdateError,
  resetPfInsureds,
  resetPfInsuredUpdate,
} = pfInsuredsSlice.actions;

export const getPfInsureds = (state: RootState) => state.pfInsuredsReducer;

export default pfInsuredsSlice.reducer;
